import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import type { AddExtraAmcVisitRequest } from "features/Amc/types/amc.types";

type AddExtraAmcVisitModalProps = {
  isOpen: boolean;
  toggle: () => void;
  contractLabel?: string | null;
  submitting?: boolean;
  onConfirm: (body: AddExtraAmcVisitRequest) => void | Promise<void>;
};

export default function AddExtraAmcVisitModal({
  isOpen,
  toggle,
  contractLabel,
  submitting = false,
  onConfirm,
}: AddExtraAmcVisitModalProps) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Add extra visit</ModalHeader>
      <ModalBody>
        <p className="text-muted small mb-0">
          Adds an <strong>extra</strong> visit row for{" "}
          <span className="fw-medium text-body">
            {contractLabel?.trim() || "this contract"}
          </span>
          . The contract&apos;s scheduled visit count is not changed.
        </p>
      </ModalBody>
      <ModalFooter className="d-flex gap-2">
        <Button color="light" type="button" onClick={toggle} disabled={submitting}>
          Cancel
        </Button>
        <Button
          color="primary"
          type="button"
          onClick={() => void onConfirm({})}
          disabled={submitting}
        >
          {submitting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden
              />
              Adding…
            </>
          ) : (
            "Add visit"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
